import { Link } from 'gatsby';
import React from 'react'
import styled from 'styled-components'

const Svg = styled(Link)`
    svg {
        cursor: pointer;
    }
`
interface FrProps {

}

const Fr: React.FC<FrProps> = ({}) => {
    let str = ''
    let location
    if(typeof window !== 'undefined') {
        location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
       }
        return (
            <>
            {/* *ENglish */}
             {str !== 'fr-fr' ?
            <Link to={location == '/about' || location == '/about/' ? '/fr-fr/a-propos' : location == '/services' || location == '/services/' ? '/fr-fr/nos-services': location =='/en-us/resource' || location == '/en-us/resource/' ? '/fr-fr/resource' : location == '/contact' || location =='/contact/' ? '/fr-fr/nos-contacter' : '/fr-fr'} className='lang'>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="18" r="18" fill="#FF4C55"/>
                <path d="M9.74169 24V12.896H11.2457V24H9.74169ZM10.7657 19.12V17.744H16.5577V19.12H10.7657ZM10.7657 14.272V12.896H16.8297V14.272H10.7657ZM19.8122 19.168V17.904H22.8202C23.4709 17.904 23.9722 17.7387 24.3242 17.408C24.6762 17.0773 24.8522 16.6293 24.8522 16.064C24.8522 15.5307 24.6762 15.088 24.3242 14.736C23.9829 14.384 23.4869 14.208 22.8362 14.208H19.8122V12.896H22.8842C23.5882 12.896 24.2015 13.0347 24.7242 13.312C25.2469 13.5787 25.6469 13.9467 25.9242 14.416C26.2122 14.8853 26.3562 15.424 26.3562 16.032C26.3562 16.6613 26.2122 17.2107 25.9242 17.68C25.6469 18.1493 25.2469 18.5173 24.7242 18.784C24.2015 19.04 23.5882 19.168 22.8842 19.168H19.8122ZM18.8042 24V12.896H20.3082V24H18.8042ZM25.2042 24L21.1722 19.024L22.5962 18.528L27.1082 24H25.2042Z" fill="white"/>
            </svg>
        </Link>
        
        :
        
        <Link to={location == '/fr-fr/a-propos' || location =='/fr-fr/a-propos/' ? '/about': location =='/fr-fr/nos-services' || location == '/fr-fr/nos-services/' ? '/services' : location =='/fr-fr/resource' || location == '/fr-fr/resource/' ? '/en-us/resource' : location =='/fr-fr/nos-contacter' || location =='/fr-fr/nos-contacter/' ? '/contact' : '/'} className='lang'> 
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#FF4C55"/>
            <path d="M9.41356 24V12.896H10.9176V24H9.41356ZM10.4376 24V22.624H16.8056V24H10.4376ZM10.4376 18.976V17.664H16.2776V18.976H10.4376ZM10.4376 14.272V12.896H16.7256V14.272H10.4376ZM18.8511 24V12.896H19.9071L20.3551 14.64V24H18.8511ZM26.5311 24L19.7151 14.896L19.9071 12.896L26.7391 21.984L26.5311 24ZM26.5311 24L26.0831 22.352V12.896H27.5871V24H26.5311Z" fill="white"/>
        </svg>
     </Link>
            }
            </>
           
           
        );
}
export default Fr